import { z } from 'zod';
import { LIMITS } from '../limits.js';

const email = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.email({ message: 'Adresse e-mail invalide' }).max(254));

const password = z
  .string()
  .min(LIMITS.passwordMin, `Au moins ${LIMITS.passwordMin} caractères`)
  .max(LIMITS.passwordMax, `Au plus ${LIMITS.passwordMax} caractères`);

export const registerSchema = z.object({
  email,
  name: z.string().trim().min(1, 'Nom requis').max(LIMITS.userName),
  password,
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email,
  password: z.string().min(1, 'Mot de passe requis').max(LIMITS.passwordMax),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const THEMES = ['system', 'light', 'dark'] as const;
export const LAYOUTS = ['grid', 'list'] as const;

const preferencesShape = {
  theme: z.enum(THEMES),
  layout: z.enum(LAYOUTS),
  /** Déplace les éléments cochés en bas des listes (comportement par défaut de Keep). */
  moveCheckedToBottom: z.boolean(),
};

export const preferencesSchema = z.object(preferencesShape);
export type Preferences = z.infer<typeof preferencesSchema>;

export const DEFAULT_PREFERENCES: Preferences = {
  theme: 'system',
  layout: 'grid',
  moveCheckedToBottom: true,
};

export const updateProfileSchema = z.object({
  name: z.string().trim().min(1).max(LIMITS.userName).optional(),
  // Pas de valeurs par défaut ici : une mise à jour partielle ne doit pas écraser les autres préférences.
  preferences: z.object(preferencesShape).partial().optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(LIMITS.passwordMax),
  newPassword: password,
});
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export interface UserDto {
  id: string;
  email: string;
  name: string;
  preferences: Preferences;
  createdAt: string;
}

export interface PublicUserDto {
  id: string;
  email: string;
  name: string;
}
